import { Bell } from 'lucide-react';
import { Link, Outlet } from 'react-router-dom';

import { BottomNav, Sidebar } from '@/components/Nav';
import { JemmiLogo } from '@/components/JemmiLogo';
import { TestSessionBadge } from '@/components/TestSessionBadge';
import { useNotifications } from '@/hooks/useNotifications';

/**
 * AppShell wraps every routed page with the persistent chrome:
 *   - Mobile: test-session badge + top bar + bottom nav
 *   - Desktop: left sidebar (includes the test-session badge)
 *
 * The page renders into <Outlet />.
 */
export function AppShell() {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 antialiased">
      <TestSessionBadge />
      <MobileTopBar />

      <div className="mx-auto flex max-w-6xl px-4 lg:px-8 lg:py-8">
        <Sidebar />
        <main className="min-w-0 flex-1 pb-24 pt-4 lg:pb-8 lg:pt-0">
          <Outlet />
        </main>
      </div>

      <BottomNav />
    </div>
  );
}

function MobileTopBar() {
  const { unreadCount } = useNotifications();
  return (
    <header className="sticky top-0 z-20 border-b border-slate-200/70 bg-white/85 backdrop-blur-xl lg:hidden">
      <div className="flex h-14 items-center justify-between px-4">
        <JemmiLogo size="sm" />
        <Link
          to="/notifications"
          aria-label="Notifications"
          className="relative flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-slate-700"
        >
          <Bell className="h-4 w-4" />
          {unreadCount > 0 && (
            <span className="absolute right-1 top-1 h-2 w-2 rounded-full bg-red-500 ring-2 ring-white" />
          )}
        </Link>
      </div>
    </header>
  );
}
